import { create } from 'zustand';
import { EBottomBarActiveItem } from 'components-new/eCommerce/BottomBar/types';

interface ECommerceState {
  activeItem: EBottomBarActiveItem;
}

interface ECommerceActions {
  setActiveItem: (item: EBottomBarActiveItem) => void;
}

export const useECommerceStore = create<ECommerceState & ECommerceActions>((set) => ({
  // State
  activeItem: EBottomBarActiveItem.cart,

  // Actions
  setActiveItem: (item) => set({ activeItem: item }),
}));
